// Single source of truth for CoachER pricing. Update here only.
export const PRICING = {
  monthly: {
    amount: 6.99,
    display: "$6.99",
    period: "per month",
  },
  annual: {
    amount: 59,
    display: "$59",
    period: "per year",
    monthlyEquivalent: "$4.92",
    savingsAmount: "$24.88",
    savingsPercent: 30,
    twelveMonthAtMonthly: "$83.88",
    badge: "BEST VALUE — SAVE ~30%",
  },
  trial: {
    playerLimit: 3,
  },
};

export const CONTACT_EMAIL = "support@trycoacher.com";

export const COMPANY = {
  name: "Build Make Win Ventures",
  url: "https://buildmakewin.com",
  location: "Ohio, USA",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testId: "nav-home-link" },
  { to: "/mission", label: "Mission", testId: "nav-mission-link" },
  { to: "/about", label: "About Us", testId: "nav-about-link" },
  { to: "/features", label: "Features", testId: "nav-features-link" },
  { to: "/pricing", label: "Pricing", testId: "nav-pricing-link" },
  { to: "/contact", label: "Contact Us", testId: "nav-contact-link" },
];

export const SCREENSHOTS = [
  {
    src: "/assets/app-practice.jpeg",
    num: "01",
    title: "AI Practice Plans",
    blurb: "Timed stations, drill notes, and coaching points — built around your roster.",
  },
  {
    src: "/assets/app-lineup.jpeg",
    num: "02",
    title: "Field Lineup Builder",
    blurb: "Set all 9 positions and your bench, inning by inning, with AI Suggest.",
  },
  {
    src: "/assets/app-batting.jpeg",
    num: "03",
    title: "AI Batting Order",
    blurb: "An order built from your coaching notes, player development, and handedness.",
  },
  {
    src: "/assets/app-signup.jpeg",
    num: "04",
    title: "Dugout Setup",
    blurb: "Head Coach and Assistant roles from the first sign-in.",
  },
];
